import React from 'react';
import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/cn';

type Props = {
    title: string;
    rightComponent: React.ReactNode;
    className?: string;
};

const SectionTitle = ({ title, rightComponent, className }: Props): JSX.Element => {
    return (
        <div className={cn('flex w-full flex-wrap items-center justify-between py-2', className)}>
            <h5 className="text-h5">
                <FormattedMessage id={title} />
            </h5>
            <div>{rightComponent}</div>
        </div>
    );
};

export default SectionTitle;
